/* Henry page (lph-* sections). Loaded once per section; runs once. */
(function(){
  if(window.__lph)return;window.__lph=1;
  function ready(f){document.readyState==='loading'?document.addEventListener('DOMContentLoaded',f):f()}
  ready(function(){
  var reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var roots=[].slice.call(document.querySelectorAll('.lph'));
  var $=function(id){return document.getElementById(id)};

  /* ---- no orphans: tie the last two words together ---- */
  function noOrphan(scope){
    scope.querySelectorAll('h1,h2,h3,h4,p,li,summary,blockquote,.t,.note-card span,.mail .p,.flo span,.hd>span,small').forEach(function(el){
      if((el.textContent||'').trim().split(/\s+/).length<4)return;
      var w=document.createTreeWalker(el,NodeFilter.SHOW_TEXT,null),n,ts=[];
      while((n=w.nextNode())){if(n.nodeValue.trim())ts.push(n)}
      if(!ts.length)return;
      var last=ts[ts.length-1],v=last.nodeValue,tr=v.replace(/\s+$/,''),i=tr.lastIndexOf(' ');
      if(i>0){last.nodeValue=tr.slice(0,i)+' '+tr.slice(i+1)+v.slice(tr.length);return}
      var prev=ts[ts.length-2];if(prev&&/ $/.test(prev.nodeValue))prev.nodeValue=prev.nodeValue.replace(/ $/,' ');
    });
  }
  roots.forEach(noOrphan);

  /* ---- scroll reveal ---- */
  if('IntersectionObserver' in window && !reduce){
    roots.forEach(function(r){r.classList.add('js')});
    var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target)}})},{threshold:.08});
    var vh0=window.innerHeight||800;
    document.querySelectorAll('.lph .rv').forEach(function(el){if(el.getBoundingClientRect().top>vh0*.9)el.classList.add('hide');io.observe(el)});
    setTimeout(function(){document.querySelectorAll('.lph .rv').forEach(function(el){el.classList.add('in')})},2500);
  }

  /* ---- scroll-linked motion: hero cards fan out (desktop), screens rise ---- */
  var desk=window.matchMedia('(min-width:900px)');
  var fan=document.querySelector('.lph [data-fan]'),cards=fan?[].slice.call(fan.querySelectorAll('.fcd')):[];
  var row=$('lscRow'),rise=row?[].slice.call(row.querySelectorAll('.lsc-card')):[];
  function clamp(x){return x<0?0:x>1?1:x}
  function measure(){
    if(fan){var c=fan.offsetWidth/2;cards.forEach(function(el){el.style.setProperty('--tx',(c-(el.offsetLeft+el.offsetWidth/2)).toFixed(1)+'px')})}
    frame();
  }
  var ticking=false;
  function frame(){
    ticking=false;var vh=window.innerHeight||800;
    if(fan){var r=fan.getBoundingClientRect();var p=(reduce||!desk.matches)?1:.14+.86*clamp(1-(r.top-vh*.2)/(vh*.55));fan.style.setProperty('--p',p.toFixed(3))}
    if(row){
      if(!desk.matches||reduce){rise.forEach(function(el){el.style.transform=''})}
      else{var rr=row.getBoundingClientRect();var q=clamp((vh-rr.top)/(vh*.8));rise.forEach(function(el,i){el.style.transform='translate3d(0,'+((1-q)*(70+i*55)).toFixed(1)+'px,0)'})}
    }
  }
  function onScroll(){if(!ticking){ticking=true;requestAnimationFrame(frame)}}
  measure();window.addEventListener('scroll',onScroll,{passive:true});window.addEventListener('resize',measure);window.addEventListener('load',measure);

  /* screens carousel dots (phones) */
  var dots=$('lscDots');
  if(row&&dots){var ds=[].slice.call(dots.children);row.addEventListener('scroll',function(){var first=row.children[0];if(!first)return;var w=first.getBoundingClientRect().width+14;var i=Math.round(row.scrollLeft/w);ds.forEach(function(d,j){d.classList.toggle('on',j===i)})},{passive:true})}

  /* ---- hero ---- */
  var ht=$('heroTwin');if(ht)setTimeout(function(){ht.classList.add('done')},4400);
  var typed=$('heroTyped'),inn=$('heroIn'),home=$('homeTyped');
  if(typed){
    var ph=typed.getAttribute('data-ph')||'Tell Henry';if(home)home.textContent=ph;
    var lines=(typed.getAttribute('data-lines')||'').split('|||').filter(function(x){return x.trim()});
    if(lines.length&&!reduce){var li=0;var typeOne=function(){var t=lines[li++%lines.length],k=0;if(inn)inn.classList.add('typing');(function tk(){typed.textContent=t.slice(0,++k);if(k<t.length)setTimeout(tk,60);else setTimeout(function(){typed.textContent=ph;if(inn)inn.classList.remove('typing');setTimeout(typeOne,2200)},1400)})()};setTimeout(typeOne,1500)}
  }

  /* ---- not a chatbot: one thread with an Assistant / Henry switch ---- */
  var data=$('lphCmp'),C=[];try{C=JSON.parse(data?data.textContent:'[]')}catch(e){}
  var wrap=document.querySelector('.lph .compare');
  if(C.length&&wrap){
    var chips=[].slice.call(document.querySelectorAll('.lph .chips .chip')),seg=$('cmpSeg');
    var A=function(k,d){return wrap.getAttribute('data-'+k)||d};
    var TW='<span class="twin speak" style="--s:22px;--bl:2px"><i class="ta"></i><i class="tb"></i></span>';
    var k=0,view='hen',auto=A('auto','true')!=='false',flip=null,timers=[];
    var wc=function(t){return t.trim()?t.trim().split(/\s+/).length:0},qs=function(t){return (t.match(/\?/g)||[]).length};
    var esc=function(t){var d=document.createElement('div');d.textContent=t;return d.innerHTML};
    function render(type){
      timers.forEach(clearTimeout);timers=[];
      var c=C[k];$('thYou').textContent=c.you;
      seg.classList.toggle('r',view==='bot');seg.querySelectorAll('button').forEach(function(b){b.setAttribute('aria-pressed',b.getAttribute('data-v')===view?'true':'false')});
      var r=$('thReply');
      if(view==='bot'){
        $('thTitle').textContent=A('bot','Assistant');$('thMeta').textContent='● ● ●';$('thPh').textContent=A('botph','Ask me anything…');$('thGo').style.background='#D9D0C2';
        r.innerHTML='<div class="clamp"><div class="bub h"></div></div>';var bub=r.querySelector('.bub');
        if(type&&!reduce){var words=c.bot.split(' '),i=0;(function tick(){if(i<words.length){bub.textContent=words.slice(0,++i).join(' ');timers.push(setTimeout(tick,32))}})()}else bub.textContent=c.bot;
      }else{
        $('thTitle').innerHTML=TW+'Henry';$('thMeta').textContent=A('henmeta','KEPT · 12');$('thPh').textContent=A('henph','Tell Henry');$('thGo').style.background='#F0D6B5';
        r.innerHTML=c.hen?'<div class="bub h">'+esc(c.hen)+'</div>':'<div class="bub k">'+esc(A('kept','Kept'))+'</div>';
      }
      $('scBotN').textContent=wc(c.bot);$('scBotT').textContent='words · '+qs(c.bot)+' questions · '+A('bot','Assistant');
      $('scHenN').textContent=wc(c.hen);$('scHenT').textContent=c.hen?'words · done · Henry':'words · kept, no reply · Henry';
      $('scBot').classList.toggle('on',view==='bot');$('scHen').classList.toggle('on',view==='hen');
    }
    function pick(n){k=n;view='hen';chips.forEach(function(b){b.setAttribute('aria-pressed',+b.getAttribute('data-k')===n?'true':'false')});render(true);clearTimeout(flip);if(auto&&!reduce)flip=setTimeout(function(){view='bot';render(true)},3600)}
    chips.forEach(function(b){b.addEventListener('click',function(){auto=false;pick(+b.getAttribute('data-k'))})});
    seg.querySelectorAll('button').forEach(function(b){b.addEventListener('click',function(){auto=false;clearTimeout(flip);view=b.getAttribute('data-v');render(view==='bot')})});
    pick(0);
    setInterval(function(){if(!auto||reduce||document.hidden)return;pick((k+1)%C.length)},9000);
  }

  /* ---- let go: one button per row ---- */
  var held=$('held');
  if(held){
    var items=[].slice.call(held.querySelectorAll('.it')),G=function(k,d){return held.getAttribute('data-'+k)||d};
    var count=function(){var n=items.filter(function(x){return !x.classList.contains('gone')}).length,g=items.length-n;$('heldCount').textContent=G('things','[n] things').replace('[n]',n);$('heldFt').textContent=g?G('gone','Let [n] go, kept [k].').replace('[n]',g).replace('[k]',n):G('none','')};
    var touched=false,setGone=function(it,g){it.classList.toggle('gone',g);it.querySelector('button').textContent=g?G('back','Bring back'):G('go','Let go');count()};
    items.forEach(function(it){var b=it.querySelector('button');b.addEventListener('click',function(){touched=true;items.forEach(function(x){x.classList.remove('out')});setGone(it,!it.classList.contains('gone'))})});
    count();
    /* movement: rows settle in, then Henry clears the ones that are already done */
    if(!reduce&&'IntersectionObserver' in window){
      held.classList.add('live');
      items.forEach(function(it,i){it.style.transitionDelay=(i*0.09)+'s'});
      var auto=items.filter(function(it){var m=it.querySelector('small');return m&&/\bdone\b/i.test(m.textContent)});
      held.setAttribute('data-auto','armed');var hvis=false,started=false,busy=false,later=function(fn,ms){setTimeout(function(){if(!touched)fn()},ms)};
      var cycle=function(){
        if(touched||busy)return;busy=true;held.setAttribute('data-auto','run');
        auto.forEach(function(it,i){
          later(function(){it.classList.add('flash')},i*1100);
          later(function(){it.classList.remove('flash');setGone(it,true)},i*1100+450);
          later(function(){it.classList.add('out')},i*1100+1700);
        });
        var back=auto.length*1100+1700+3200;
        auto.forEach(function(it,i){later(function(){it.classList.remove('out')},back+i*250);later(function(){setGone(it,false)},back+i*250+500)});
        later(function(){busy=false;held.setAttribute('data-auto','rest');if(hvis)cycle()},back+auto.length*250+3400);
      };
      new IntersectionObserver(function(es){es.forEach(function(e){hvis=e.isIntersecting&&e.intersectionRatio>=.3;
        if(hvis&&!started){started=true;var wr=held.parentElement;if(wr)wr.style.minHeight=wr.offsetHeight+'px';held.classList.add('in');setTimeout(function(){items.forEach(function(it){it.style.transitionDelay=''})},1400);setTimeout(cycle,1600)}
        else if(hvis)cycle();
      })},{threshold:[0,.3,.6]}).observe(held);
    }
  }

  /* ---- steps: light walks tell -> keep -> bring back, then rests ---- */
  var steps=document.querySelector('.lph .lsteps');
  if(steps&&!reduce&&'IntersectionObserver' in window){
    var sts=[].slice.call(steps.querySelectorAll('.lst')),si=-1,stT=null,vis=false;
    steps.classList.add('live');
    var show=function(i){si=i;sts.forEach(function(x,j){x.classList.toggle('on',j<=i)});steps.style.setProperty('--prog',sts.length>1?Math.max(0,i)/(sts.length-1):1)};
    var run=function(){clearTimeout(stT);show(0);var k=0;(function next(){stT=setTimeout(function(){k++;if(k<sts.length){show(k);next()}else{stT=setTimeout(function(){if(!vis){stT=null;return}sts.forEach(function(x){x.classList.remove('on')});steps.style.setProperty('--prog',0);stT=setTimeout(run,900)},5200)}},2000)})()};
    new IntersectionObserver(function(es){es.forEach(function(e){vis=e.isIntersecting;if(vis&&si<0)run();else if(vis&&!stT)run()})},{threshold:.4}).observe(steps);
  }

  /* ---- privacy: one lock screen with a switch ---- */
  var lw=$('lockWrap');
  if(lw){
    var ls=$('lockSeg');
    var lock=function(v){ls.classList.toggle('r',v!=='hen');ls.querySelectorAll('button').forEach(function(b){b.setAttribute('aria-pressed',b.getAttribute('data-v')===v?'true':'false')});
      var a=$('stkAll'),h=$('stkHen');a.hidden=v==='hen';h.hidden=v!=='hen';
      [a,h].forEach(function(s){if(!s.hidden){[].slice.call(s.children).forEach(function(c){c.style.animation='none';void c.offsetWidth;c.style.animation=''})}});
      $('lockCap').textContent=v==='hen'?lw.getAttribute('data-henry'):lw.getAttribute('data-others')};
    ls.querySelectorAll('button').forEach(function(b){b.addEventListener('click',function(){lock(b.getAttribute('data-v'))})});
  }

  /* ---- waitlist ---- */
  var f=$('wlForm');
  if(f){
    var sec=$('waitlist'),em=$('wlEmail'),tw=$('wlTwin'),btn=f.querySelector('button');
    var setState=function(st){if(!tw)return;tw.classList.remove('listen','speak');if(st)tw.classList.add(st)};
    em.addEventListener('focus',function(){setState('listen')});
    em.addEventListener('blur',function(){if(!sec.classList.contains('done'))setState('')});
    f.addEventListener('submit',function(e){
      e.preventDefault();
      if(!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(em.value)){em.focus();em.setCustomValidity('Add an email');em.reportValidity();em.setCustomValidity('');return}
      btn.disabled=true;setState('speak');
      var p=window.lpKlaviyoCapture?window.lpKlaviyoCapture({email:em.value.trim(),source:sec.getAttribute('data-source')||'Henry Page',eventName:'Henry Waitlist Signup',listId:sec.getAttribute('data-list')||'XmA4Ji',properties:{'Henry Waitlist':true,'Signup Source':'henry-v2-page'}}):Promise.resolve();
      Promise.resolve(p).catch(function(err){console.error('Klaviyo capture failed:',err)}).then(function(){
        sec.classList.add('done');f.hidden=true;['wlHead','wlSub','wlFine'].forEach(function(id){var x=$(id);if(x)x.hidden=true});['wlDone','wlOk'].forEach(function(id){var x=$(id);if(x)x.hidden=false});
        setTimeout(function(){setState('')},2200);
      });
    });
  }
  });
})();
